import apiClient from './apiClient';

export async function listRecommendations(filters = {}) {
  const res = await apiClient.get('/recommendations', { params: filters });
  return res.data.data.items;
}
export async function setStatus(recommendationId, status) {
  const res = await apiClient.patch(`/recommendations/${recommendationId}/status`, { status });
  return res.data.data;
}
export async function refreshRecommendations() {
  const res = await apiClient.post('/recommendations/refresh');
  return res.data.data;
}
